import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { Form, Button, Grid, Header } from "semantic-ui-react";
import { TextInput } from "../templates/utils/form-fields";
import { ApiRequest } from "../firebase/server";
import { fetchRangeSearch, fetchError } from "../actions";

let SearchRangeForm = ({ submitting, pristine, handleSubmit }) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const handleSubmitForm = async (values) => {
    setLoading(true);
    //let data = {};
    ApiRequest({
      tpnb: values.tpnb,
      tpnc: values.tpnc,
      storeId: values.store,
      country: values.country,
      retailer: "tesco",
      service: "rangeService",
    })
      //.then((results) => {
      //  data = results;
      //  return ApiRequest({
      //    tpnb: results.result.productData.tpnb.slice(1),
      //    retailer: "tesco",
      //    service: "spectra",
      //  });
      //})
      .then((results) => {
        //data.result.spectra = results.result.mediaSummaries;
        dispatch(fetchRangeSearch(results));
        setLoading(false);
      })
      .catch((error) => {
        console.log("error", error.message);
        dispatch(
          fetchError({
            name: "Range error",
            error: "Can't find a match for that TPNB or Product ID",
            size: "small",
          })
        );
        setLoading(false);
      });
  };

  return (
    <Form onSubmit={handleSubmit(handleSubmitForm)}>
      <Grid padded>
        <Grid.Row>
          <Grid.Column>
            <Header as="h3">Grocery availability and range check</Header>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column computer={2} tablet={4} mobile={16}>
            <Field
              name="tpnb"
              label="TPNB"
              type="number"
              component={TextInput}
              placeholder="TPNB"
            />
          </Grid.Column>
          <Grid.Column computer={2} tablet={4} mobile={16}>
            <Field
              name="tpnc"
              label="Product ID"
              type="number"
              component={TextInput}
              placeholder="Product ID"
            />
          </Grid.Column>
          <Grid.Column computer={2} tablet={4} mobile={16}>
            <Field
              name="store"
              label="Store ID"
              type="number"
              component={TextInput}
              placeholder="Store ID"
            />
          </Grid.Column>
          <Grid.Column computer={2} tablet={4} mobile={16}>
            <Field
              name="country"
              label="Country"
              type="text"
              component={TextInput}
              placeholder="Country"
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Button
              type="submit"
              positive
              size="small"
              disabled={submitting || pristine}
              loading={loading}
            >
              Submit
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

const validate = (values) => {
  const errors = {};

  if (values.tpnb && values.tpnb.length < 8) {
    errors.tpnb = "Please enter a valid TPNB";
  }

  if (values.tpnc && values.tpnc.length < 9) {
    errors.tpnc = "Please enter a valid Product Id";
  }

  if (!values.tpnb && !values.tpnc) {
    errors.tpnb = "Please enter a TPNB or Product ID";
  }

  return errors;
};

SearchRangeForm = reduxForm({
  validate,
  form: "searchRangeForm",
})(SearchRangeForm);

export default SearchRangeForm;
